import { Registry } from '@react-registry'

export const H1Deserializer = () => {
    return {
        type: 'h1',
    }
}

Registry.register(H1Deserializer, { id: 'H1', registry: 'deserializer' })